import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { connection } from "utils/apiConnection.ts";
import AuthenticationContext from "Authentication/AuthenticationContext.ts";

const PermissionButton: React.FC<{ suplierId: number }> = ({
  suplierId = 29,
}) => {
  const { grantPermissions } = useContext(AuthenticationContext);

  function handler() {
    grantPermissions(suplierId);
  }

  return (
    <>
      <button className="btn btn-info" onClick={handler}>
        به عنوان ادمین فروشگاه وارد سایت شوید.
      </button>

      <Link to="/admin-panel/2" className="btn btn-primary">
        Admin Panel
      </Link>
    </>
  );
};

export default PermissionButton;